import { render, staticRenderFns } from "./CardEstimate.vue?vue&type=template&id=0b20e2df&"
import script from "./CardEstimate.vue?vue&type=script&lang=js&"
export * from "./CardEstimate.vue?vue&type=script&lang=js&"
import style0 from "./CardEstimate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports